import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-file fa-w-12 mr-1" }),
    /*#__PURE__*/_createTextVNode(" Requested Invoice ")
  ])
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "invoice" }, "Choose a Invoice:", -1)
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "row align-items-center" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "inline-items" }
const _hoisted_10 = {
  key: 0,
  class: "mr-md-5"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Invoice No: ")
const _hoisted_12 = { class: "green-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Invoice Date: ")
const _hoisted_15 = { class: "green-text" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_17 = { class: "text-md-right" }
const _hoisted_18 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_19 = {
  key: 0,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_20 = {
  key: 1,
  class: "badge badge-dim badge-warning ml-1 text-orange"
}
const _hoisted_21 = {
  key: 2,
  class: "badge badge-dim badge-warning ml-1 text-green"
}
const _hoisted_22 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1 text-red"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Billed From :")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 4 }
const _hoisted_32 = { key: 5 }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Billed To :")
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { key: 5 }
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Title :")
const _hoisted_43 = { class: "table-responsive my-3 font-12" }
const _hoisted_44 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_45 = { class: "table-primary nowrap-text" }
const _hoisted_46 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Description", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Cost/hrs", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Qty/hrs", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Amount", -1)
const _hoisted_50 = {
  key: 0,
  scope: "col"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "fa fa-minus" }, null, -1)
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 0,
  class: "row"
}
const _hoisted_56 = { class: "col-md-4 offset-md-8" }
const _hoisted_57 = { class: "shadowed-card" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "SubTotal")
  ])
], -1)
const _hoisted_60 = { class: "col-6 text-right" }
const _hoisted_61 = { class: "mb-1" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Tax")
  ])
], -1)
const _hoisted_63 = { class: "col-6 text-right" }
const _hoisted_64 = { class: "mb-1" }
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Discount")
  ])
], -1)
const _hoisted_66 = { class: "col-6 text-right" }
const _hoisted_67 = { class: "mb-1" }
const _hoisted_68 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-6" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_72 = { class: "col-6 text-right" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = {
  key: 1,
  class: "row"
}
const _hoisted_76 = { class: "col-md-4 offset-md-8" }
const _hoisted_77 = { class: "shadowed-card" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "SubTotal")
  ])
], -1)
const _hoisted_80 = { class: "col-6 text-right" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = { class: "col-6" }
const _hoisted_84 = { class: "col-6 text-right" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Discount")
  ])
], -1)
const _hoisted_88 = { class: "col-6 text-right" }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_92 = { class: "row" }
const _hoisted_93 = { class: "col-6" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_95 = { class: "col-6 text-right" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "inline-items" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { key: 2 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = /*#__PURE__*/_createVNode("p", null, "You don't have Stripe Account !!!", -1)
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbRequestedInvoice = _resolveComponent("BreadcrumbRequestedInvoice")
  const _component_big = _resolveComponent("big")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getInvoiceByPhaseOrTask)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_BreadcrumbRequestedInvoice, {
      breadcrumbList: _ctx.state.data.breadcrumb
    }, null, 8, ["breadcrumbList"]),
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _hoisted_5,
        _withDirectives(_createVNode("select", {
          name: "invoice",
          id: "invoice",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.selectedInvoice = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getInvoiceByPhaseOrTask(_ctx.state.data.selectedInvoice)))
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invoices, (invoice, invoiceIndex) => {
            return (_openBlock(), _createBlock("option", {
              value: invoice,
              key: invoiceIndex
            }, " #" + _toDisplayString(invoice.invoice_no) + "(" + _toDisplayString(invoice.invoice_date) + ") ", 9, ["value"]))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.state.data.selectedInvoice]
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("ul", null, [
              (
                  _ctx.state.data.invoiceDetails &&
                  _ctx.state.data.invoiceDetails.invoice_no
                )
                ? (_openBlock(), _createBlock("li", _hoisted_10, [
                    _createVNode("p", null, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createVNode("strong", null, [
                            _hoisted_11,
                            _createVNode("span", _hoisted_12, "#" + _toDisplayString(_ctx.state.data.invoiceDetails.invoice_no), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("li", null, [
                (
                    _ctx.state.data.invoiceDetails &&
                    _ctx.state.data.invoiceDetails.invoice_date
                  )
                  ? (_openBlock(), _createBlock("p", _hoisted_13, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createVNode("strong", null, [
                            _hoisted_14,
                            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.state.data.invoiceDetails.invoice_date), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.status)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("p", null, [
                  _hoisted_18,
                  (_ctx.state.data.invoiceDetails.status === 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_19, "Pending"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 2)
                    ? (_openBlock(), _createBlock("span", _hoisted_20, "Partial Paid"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 3)
                    ? (_openBlock(), _createBlock("span", _hoisted_21, "Paid"))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.invoiceDetails.status === 4)
                    ? (_openBlock(), _createBlock("span", _hoisted_22, "Halt"))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_23,
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_24, [
        _createVNode("div", _hoisted_25, [
          _createVNode("p", null, [
            _createVNode("strong", null, [
              _createVNode(_component_big, null, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ])
          ]),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.email
            )
            ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.email), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.full_name
            )
            ? (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.full_name), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line1
            )
            ? (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line1), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line2
            )
            ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line2), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.city
            )
            ? (_openBlock(), _createBlock("p", _hoisted_31, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.city), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.country
            )
            ? (_openBlock(), _createBlock("p", _hoisted_32, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.country), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("p", null, [
            _createVNode("strong", null, [
              _createVNode(_component_big, null, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              })
            ])
          ]),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.email
            )
            ? (_openBlock(), _createBlock("p", _hoisted_35, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.email), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.full_name
            )
            ? (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.full_name), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.address_line1
            )
            ? (_openBlock(), _createBlock("p", _hoisted_37, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line1), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.address_line2
            )
            ? (_openBlock(), _createBlock("p", _hoisted_38, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line2), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.city
            )
            ? (_openBlock(), _createBlock("p", _hoisted_39, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.city), 1))
            : _createCommentVNode("", true),
          (
              _ctx.state.data.invoiceDetails.billed_to_user &&
              _ctx.state.data.invoiceDetails.billed_to_user.country
            )
            ? (_openBlock(), _createBlock("p", _hoisted_40, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.country), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("p", _hoisted_41, [
        _createVNode("strong", null, [
          _createVNode(_component_big, null, {
            default: _withCtx(() => [
              _hoisted_42
            ]),
            _: 1
          })
        ]),
        _createTextVNode(" " + _toDisplayString(_ctx.state.data.invoiceDetails.title), 1)
      ]),
      _createVNode("div", _hoisted_43, [
        _createVNode("table", _hoisted_44, [
          _createVNode("thead", _hoisted_45, [
            _createVNode("tr", null, [
              _hoisted_46,
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              (_ctx.isAuthEdit)
                ? (_openBlock(), _createBlock("th", _hoisted_50, "Action"))
                : _createCommentVNode("", true)
            ])
          ]),
          (
              _ctx.isAuthEdit &&
              _ctx.state.data.invoiceDetails.invoice_items &&
              _ctx.state.data.invoiceDetails.invoice_items.length
            )
            ? (_openBlock(), _createBlock("tbody", _hoisted_51, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceCalculate, (invoiceDetail, invoiceDetailIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.title = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.title]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.cost = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.cost]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.quantity = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.quantity]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        disabled: "",
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => (invoiceDetail.amount = $event)
                      }, null, 8, ["onUpdate:modelValue"]), [
                        [_vModelText, invoiceDetail.amount]
                      ])
                    ]),
                    _createVNode("td", null, [
                      (invoiceDetailIndex + 1 === _ctx.invoiceCalculate.length)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            class: "btn enable-btn mr-1",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addItemInInvoice && _ctx.addItemInInvoice(...args)))
                          }, [
                            _hoisted_52
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn delete-btn mr-1",
                        onClick: ($event: any) => (_ctx.removeSelectedItemInInvoice(invoiceDetail))
                      }, [
                        _hoisted_53
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tbody", _hoisted_54, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .invoiceDetails.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                    _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                    _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                    _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                    _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                  ]))
                }), 128))
              ]))
        ])
      ]),
      (_ctx.isAuthEdit)
        ? (_openBlock(), _createBlock("div", _hoisted_55, [
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createVNode("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.invoice.subTotal = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.subTotal]
                      ])
                    ])
                  ]),
                  _createVNode("p", null, _toDisplayString(_ctx.state.data.invoice), 1),
                  _hoisted_62,
                  _createVNode("div", _hoisted_63, [
                    _createVNode("div", _hoisted_64, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.invoice.tax = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.tax]
                      ])
                    ])
                  ]),
                  _hoisted_65,
                  _createVNode("div", _hoisted_66, [
                    _createVNode("div", _hoisted_67, [
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.invoice.discount = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.data.invoice.discount]
                      ])
                    ])
                  ])
                ]),
                _hoisted_68,
                _createVNode("div", _hoisted_69, [
                  _createVNode("div", _hoisted_70, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_71
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_72, [
                    (_ctx.state.data.invoice.total)
                      ? (_openBlock(), _createBlock("p", _hoisted_73, " $" + _toDisplayString(_ctx.state.data.invoice.total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_74, "$0"))
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_75, [
            _createVNode("div", _hoisted_76, [
              _createVNode("div", _hoisted_77, [
                _createVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createVNode("div", _hoisted_80, [
                    (_ctx.state.data.invoiceDetails.sub_total)
                      ? (_openBlock(), _createBlock("p", _hoisted_81, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.sub_total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_82, "$0"))
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, "Tax(" + _toDisplayString(_ctx.state.data.invoiceDetails.tax) + "%)", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_84, [
                    (_ctx.state.data.invoiceDetails.tax_amount)
                      ? (_openBlock(), _createBlock("p", _hoisted_85, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.tax_amount), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_86, "$0"))
                  ]),
                  _hoisted_87,
                  _createVNode("div", _hoisted_88, [
                    (_ctx.state.data.invoiceDetails.discount)
                      ? (_openBlock(), _createBlock("p", _hoisted_89, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.discount), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_90, "$0"))
                  ])
                ]),
                _hoisted_91,
                _createVNode("div", _hoisted_92, [
                  _createVNode("div", _hoisted_93, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_94
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_95, [
                    (
                    _ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.total
                  )
                      ? (_openBlock(), _createBlock("p", _hoisted_96, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.total), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_97, "$0"))
                  ])
                ])
              ])
            ])
          ])),
      _createVNode("div", _hoisted_98, [
        _createVNode("ul", null, [
          (_ctx.state.data.isPayActive)
            ? (_openBlock(), _createBlock("li", _hoisted_99, [
                _createVNode("a", {
                  id: "createNewProject",
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.choosePaymentMode && _ctx.choosePaymentMode(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment ? "Loading..." : "PAY"), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAuthEdit)
            ? (_openBlock(), _createBlock("li", _hoisted_100, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stripeAccountCheck && _ctx.stripeAccountCheck(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.generateInvoice
                  ? "Loading..."
                  : "Generate Invoice"), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.pdf_url)
            ? (_openBlock(), _createBlock("li", _hoisted_101, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn outline",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                }, "Download Pdf")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: _ctx.ture
        }, {
          default: _withCtx(() => [
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_102, [
                  _hoisted_103,
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, " Click to setup account. "))
                    : (_openBlock(), _createBlock("p", _hoisted_104, "Loading..."))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_105, [
                  (!_ctx.state.ui.isPostLoading.generateInvoice)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.generateInvoice && _ctx.generateInvoice(...args)))
                      }, " Click to Generate Invoice "))
                    : (_openBlock(), _createBlock("p", _hoisted_106, "Loading..."))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "isButton"]))
      : _createCommentVNode("", true)
  ]))
}